import React, { FC } from "react";
import { useNavigate } from "react-router-dom";

import {
  IgButton,
  IgDivider,
  IgHeaderWTooltip,
  IgPaper,
} from "@intelligems/ig-theme";
import { Grid } from "@mui/material";
import { EXPERIMENT_ROUTES } from "@src/routes/routes";
import { Experience } from "@src/store/slices/experiences/types";

import { NewActiveTest } from "./NewActiveTest";

interface ActiveTestSectionProps {
  activeExperiences: Experience[];
}
export const ActiveTestSection: FC<ActiveTestSectionProps> = ({
  activeExperiences,
}) => {
  const navigate = useNavigate();

  return (
    <Grid item container xs={12}>
      <IgPaper
        sx={{
          boxShadow: "none",
          padding: "30px 40px",
          width: "100%",
          // flexGrow: 1,
        }}
      >
        <Grid item container direction={"column"} rowSpacing={2}>
          <Grid
            item
            container
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
            rowSpacing={2}
          >
            <Grid item>
              <IgHeaderWTooltip
                sectionTitle={"Current Tests"}
                tooltipMessage={"Active tests are shown in this section."}
              />
            </Grid>

            <Grid item>
              <IgButton
                variant={"outlined"}
                onClick={() => {
                  void navigate(EXPERIMENT_ROUTES.Experiments);
                }}
              >
                View All Tests
              </IgButton>
            </Grid>
          </Grid>
          <IgDivider spacing={"m"} />
          <Grid container item sx={{ maxHeight: "400px", overflowY: "auto" }}>
            {activeExperiences.map((experiment, index) => (
              <NewActiveTest
                key={index}
                experience={experiment}
                isLastInList={index === activeExperiences.length - 1}
              />
            ))}
          </Grid>
        </Grid>
      </IgPaper>
    </Grid>
  );
};
